const lifecycles: any = {
    // created: (e: any) => console.log(`${e} created 生命周期`),
    // beforemount: (e: any) => console.log(`${e} beforemount 生命周期`),
    // mounted: (e: any) => console.log(`${e} mounted 生命周期`),
    // unmount: (e: any) => console.log(`${e} unmount 生命周期`),
    error: (e: any) => console.log(`${e} error 生命周期`),
};

export default lifecycles;
